"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCreateMeetingBodyData = exports.getCreateMeetingQueryParams = exports.getFetchAvailabilityQueryParams = exports.getEmbedded = exports.getCurrentTime = exports.getSlug = void 0;

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("transmute/get"));

var _I18n = _interopRequireDefault(require("I18n"));

var _utils = require("MeetingsLib/utils/utils");

var _analytics = require("MeetingsLib/utils/analytics");

var _enums = require("MeetingsBase/constants/enums");

var getSlug = function getSlug(state) {
  return (0, _get.default)('userSlug', state);
};

exports.getSlug = getSlug;
var getCurrentTime = (0, _get.default)('currentTime');
exports.getCurrentTime = getCurrentTime;
var getEmbedded = (0, _get.default)('embedded');
exports.getEmbedded = getEmbedded;
var getParentPageHSAnalyticsInfo = (0, _get.default)('parentPageHSAnalyticsInfo');

function getUtkToPass(embedded, parentPageHSAnalyticsInfo) {
  if (!parentPageHSAnalyticsInfo) {
    return (0, _analytics.getHubSpotUtk)();
  }

  var parentHubspotUtk = parentPageHSAnalyticsInfo.parentHubspotUtk;
  return embedded && parentHubspotUtk ? parentHubspotUtk : (0, _analytics.getHubSpotUtk)();
}

function addParentCosPageUrl(params, parentPageHSAnalyticsInfo) {
  if (!parentPageHSAnalyticsInfo) {
    return params;
  }

  var parentCosPageUrl = parentPageHSAnalyticsInfo.parentPageUrl;

  if (parentCosPageUrl) {
    return Object.assign({}, params, {
      parentCosPageUrl: parentCosPageUrl
    });
  }

  return params;
}

var getFetchAvailabilityQueryParams = function getFetchAvailabilityQueryParams(params) {
  return (0, _reselect.createSelector)([getSlug, getCurrentTime, getEmbedded, getParentPageHSAnalyticsInfo], function (slug, now, embedded, parentPageHSAnalyticsInfo) {
    var requestParams = {
      slug: slug,
      now: now,
      includeInactiveLink: (0, _utils.shouldIncludeDeleted)(params),
      hubspotUtk: getUtkToPass(embedded, parentPageHSAnalyticsInfo),
      location: window.location.host
    };
    requestParams = addParentCosPageUrl(requestParams, parentPageHSAnalyticsInfo);
    var email = (0, _get.default)('email', params);

    if (email) {
      requestParams = Object.assign({}, requestParams, {
        email: email
      });
    }

    return requestParams;
  });
};

exports.getFetchAvailabilityQueryParams = getFetchAvailabilityQueryParams;

var getCreateMeetingQueryParams = function getCreateMeetingQueryParams(state) {
  var trackingParams = state.trackingParams,
      embedded = state.embedded,
      parentPageHSAnalyticsInfo = state.parentPageHSAnalyticsInfo,
      userSlug = state.userSlug;
  var utk = getUtkToPass(embedded, parentPageHSAnalyticsInfo);
  var requestParams = Object.assign({}, trackingParams.compact(), {
    hubspotUtk: utk,
    slug: userSlug
  });
  requestParams = addParentCosPageUrl(requestParams, parentPageHSAnalyticsInfo);
  return requestParams;
};

exports.getCreateMeetingQueryParams = getCreateMeetingQueryParams;

var getCreateMeetingBodyData = function getCreateMeetingBodyData(_ref) {
  var duration = _ref.duration,
      dateTime = _ref.dateTime;
  return function (state) {
    var event = state.bookingLifecycle.event,
        _state$bookInfo = state.bookInfo,
        offline = _state$bookInfo.offline,
        allUsersBusyTimes = _state$bookInfo.allUsersBusyTimes,
        linkType = _state$bookInfo.linkType,
        bufferTime = _state$bookInfo.bufferTime,
        legalConsentEnabled = _state$bookInfo.customParams.legalConsentEnabled,
        legalConsentResponses = state.legalConsentResponses,
        userTimezone = state.userTimezone,
        formState = state.formState;
    var formFields = (0, _utils.formatCustomFormFields)(formState.customFormFields);
    var body = {
      firstName: formState.firstName,
      lastName: formState.lastName,
      email: formState.email,
      formFields: formFields,
      offline: offline,
      locale: _I18n.default.locale,
      timezone: userTimezone,
      duration: duration,
      startTime: dateTime
    };

    if (legalConsentEnabled) {
      body.legalConsentResponses = legalConsentResponses.toJS();
    }

    if (linkType === _enums.LINK_TYPES.get(_enums.MEETING_TYPES.ROUND_ROBIN)) {
      var _getRoundRobinUserIdT = (0, _utils.getRoundRobinUserIdToBook)(event, allUsersBusyTimes, bufferTime),
          chosenUserId = _getRoundRobinUserIdT.chosenUserId,
          allUserIds = _getRoundRobinUserIdT.allUserIds;

      body.likelyAvailableUserId = chosenUserId;

      if (allUserIds) {
        body.likelyAvailableUserIds = allUserIds;
      }
    }

    return body;
  };
};

exports.getCreateMeetingBodyData = getCreateMeetingBodyData;